<main>

  <div class="container-box basepadding">

    <div class="row">
      <div class="col-xs-12 col-sm-6 col-md-6 ">
        <h1>Device Submission Tracking</h1>
      </div>

      <div class="col-xs-12 col-sm-6 col-md-6 ">
        <button (click)="downloadtrackingdata()" class="btn btn-secondary download-button ">
          {{trackingData.downloadButton}}
        </button>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12 col-sm-6 col-md-6 ">
        <select class="actions" [(ngModel)]="selectedqueryvalue">
          <option [ngValue]="undefined" disabled selected>Select Query</option>
          <option *ngFor="let option of querydropdowndata.qdata" [ngValue]="option.value">
            {{ option.label }}
          </option>
        </select>
      </div>
    </div>
    <br>
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-12 ">
        <div class="form-group textarea-container sidepadding">
          <textarea class="form-control" style="resize:vertical" (keyup)="autogrow()" rows="3" (click)="autogrow()"
            id="description" #queryeditvalue [ngModel]="selectedqueryvalue">
               </textarea>
          <button class="btn btn-secondary apply-button" (click)="trackingquerybtn(queryeditvalue.value)">submit</button>

        </div>
      </div>
    </div>

    <app-custom-grid-extended [gridOptions]="gridOptions"
      (gridEvent)="fetchTransactionLogs($event)" (onDataChange)="onRowClick($event)" [transactionData]="transactionLogs"></app-custom-grid-extended>

  </div>

</main>